module.exports = __webpack_public_path__ + "static/modedemploi_en-a25a8d4e3b1857147d2c541b5626bede.pdf";